import GenericInplayScoreboardImpl from './generic-inplay-scoreboard.js';
import MojitoCore from 'mojito/core';
import { getPropTypes } from 'presentation/components/scoreboard/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * A View component that displays a generic in-play scoreboard.
 *
 * @class GenericInplayScoreboard
 * @memberof Mojito.Presentation.Components.Scoreboard
 */

/**
 * GenericInplayScoreboard component prop types.
 *
 * @extends Mojito.Presentation.Components.Scoreboard.default.ScoreboardPropTypes
 * @memberof Mojito.Presentation.Components.Scoreboard.GenericInplayScoreboard
 */
const propTypes = { ...getPropTypes() };

const defaultProps = {
    showEventIndicators: true,
};

export default UIView(
    'GenericInplayScoreboard',
    GenericInplayScoreboardImpl,
    propTypes,
    defaultProps
);
